class ProductConfigurator extends HTMLElement {
  constructor() {
    super();

    this.drawerEl = document.getElementById('drawer-configurator');
    this.formEl = this.drawerEl.querySelector('#configurator-form');
  }

  connectedCallback() {
    this.formEl.addEventListener('submit', this.handleSubmit.bind(this));
  }

  handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.formEl);
    const engravingText = formData.get('engraving-text').trim();
    const engravingVariantId = formData.get('engraving-variant-id');

    this.updateConfigurorDataset(engravingText, engravingVariantId);
    this.updateEngravingData(engravingText, engravingVariantId);

    this.closeDrawer();
  }

  closeDrawer() {
    Woolman.ModalsAndDrawers.closeModalOrDrawer('drawer-configurator');
  }

  updateConfigurorDataset(engravingText, engravingVariantId) {
    this.dataset.engravingText = engravingText || '';
    this.dataset.engravingVariantId = engravingVariantId || '';
  }

  updateEngravingData(engravingText, engravingVariantId) {
    const engravingFontTitleEl = document.querySelector(`[name="engraving-variant-id"][value="${engravingVariantId}"]`)?.dataset.title;
    const engravingTextValueEl = this.querySelector('.js-engraving-text');
    const engravingFontValueEl = this.querySelector('.js-engraving-font');

    if (engravingTextValueEl) engravingTextValueEl.textContent = engravingText;
    if (engravingFontValueEl) engravingFontValueEl.textContent = engravingFontTitleEl;

    this.manageEngravingDataVisibility(engravingText === '');
  }

  manageEngravingDataVisibility(isHidden) {
    const engravingDataEl = this.querySelector('.js-engraving-data');
    if (engravingDataEl) engravingDataEl.classList.toggle('hidden', isHidden);
  }
}
customElements.define('product-configurator', ProductConfigurator);